// chameleon.ts
import chmln from '@chamaeleonidae/chmln';

let initialized = false;

type GuideChameleonUser = {
  id: string;
  email: string | null;
  fullName?: string | null;
  appStatus: string;
  region?: string | null;
  joinedAt?: string | null;
  environment?: string;
};

function getTokenFromEnv(): string | undefined {
  if (typeof window !== 'undefined') {
    const env = (window as any).__ENV__ || {};
    return env.CHAMELEON_TOKEN || env.NEXT_PUBLIC_CHAMELEON_TOKEN;
  }
  return process.env.REACT_APP_CHAMELEON_TOKEN;
}

export function initChameleon() {
  if (initialized) return;
  if (typeof window === 'undefined') return;

  const token = getTokenFromEnv();
  if (!token) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Chameleon: no token found in env');
    }
    return;
  }

  chmln.init(token, { fastUrl: 'https://fast.chameleon.io/' });
  initialized = true;
}

export function identifyGuide(user: GuideChameleonUser) {
  if (typeof window === 'undefined') return;

  initChameleon();

  chmln.identify(user.id, {
    email: user.email ?? undefined,
    name: user.fullName ?? undefined,
    role: 'guide',
    app_status: user.appStatus,
    region: user.region ?? undefined,
    joined_at: user.joinedAt ?? undefined,
    environment: user.environment ?? undefined,
  });
}

export function clearChameleon() {
  if (typeof window === 'undefined') return;
  if (typeof (chmln as any).clear === 'function') {
    (chmln as any).clear();
  }
}
